import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomActivosFijosSeriesBodegasNitsxSedes
 * @author: Juan Camilo Villa Osorio
 * @version: jdesk_1.01.0002
 **/
class CustomActivosFijosSeriesBodegasNitsxSedes extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);

        this.arrayObjetos = new Map();
        this.arrayCampos = new Map();
        this.onClickChange = this.handlerClickChange.bind(this);


        this.crearRegistro = this.crearRegistro.bind(this);
        this.successCrear = this.successCrear.bind(this);
        this.actualiarRegistro = this.actualiarRegistro.bind(this);
        this.successActualizar = this.successActualizar.bind(this);

        this.traerPrimero = this.traerPrimero.bind(this);
        this.successtraerPrimero = this.successtraerPrimero.bind(this);
        this.traerUltimo = this.traerUltimo.bind(this);
        this.successtraerUltimo = this.successtraerUltimo.bind(this);
        this.traerPorId = this.traerPorId.bind(this);
        this.successtraerPorId = this.successtraerPorId.bind(this);
        this.validarRegistroEliminar = this.validarRegistroEliminar.bind(this);
        this.succesvalidarRegistroEliminar = this.succesvalidarRegistroEliminar.bind(this);
        this.eliminarPorId = this.eliminarPorId.bind(this);
        this.successeliminarPorId = this.successeliminarPorId.bind(this);
        this.btnModificar = false;
        this.onClickChange = this.handlerClickChange.bind(this);
        this.onClickShowTable = this.handerClickShowTable.bind(this);
        this.onClickNew = this.handlerClickNew.bind(this);
        this.onClickDelete = this.handlerClickDelete.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.registro_seleccionado = false;
        this.mostrarMensajeSeleccionModificar = this.mostrarMensajeSeleccionModificar.bind(this);
        this.mostrarMensajeSeleccionEliminar = this.mostrarMensajeSeleccionEliminar.bind(this);
        this.successValidarUniqueRegistro = this.successValidarUniqueRegistro.bind(this);
        this.traerTodos = this.traerTodos.bind(this);
        this.successtraerTodos = this.successtraerTodos.bind(this);
        this.confirmarEliminacionRegistro = this.confirmarEliminacionRegistro.bind(this);
        this.cargarSelectEstadosActivos = this.cargarSelectEstadosActivos.bind(this);
        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.limpiarCampos = this.limpiarCampos.bind(this);


        this.llenar = this.llenar.bind(this);
        this.traer_por_id = true;
        this.operacion_actual = '';
        this.sucursal_ingreso ='';



    }

    initForm() {
        console.log('Formulario CustomActivosFijosSeriesBodegasNitsxSedes,  @version: jdesk_1.01.0002, @author: Juan Camilo Villa');


        this.arrayCampos.set(1, 'activos_fijos_series_bodegas_nitsx_sedes_id');
        this.arrayCampos.set(2, 'activos_fijos_series_id');
        this.arrayCampos.set(3, 'activos_fijos_bodegas_nitsx_sedes_id');
        this.arrayCampos.set(4, 'activos_fijos_bodegas_id');
        this.arrayCampos.set(5, 'codigo_serie');
        this.arrayCampos.set(6, 'nombre_serie');
        this.arrayCampos.set(7, 'estado_serie');
        this.arrayCampos.set(8, 'codigo_bodega');
        this.arrayCampos.set(9, 'descripcion_bodega');
        this.arrayCampos.set(10, 'tipo_bodega');
        this.arrayCampos.set(11, 'tarifa');
        this.arrayCampos.set(12, 'descuento');
        this.arrayCampos.set(13, 'precio');
        this.arrayCampos.set(14, 'fecha_inicial');
        this.arrayCampos.set(15, 'fecha_final');
        this.arrayCampos.set(16, 'nit');
        this.arrayCampos.set(17, 'sede');
        this.arrayCampos.set(18, 'nombre');
        this.arrayCampos.set(19, 'estadoactivo_id');

        this.arrayCampos.set(30, 'btn_agregar');
        this.arrayCampos.set(31, 'btn_cancelar');
        this.arrayCampos.set(32, 'btn_modificar');
        this.arrayCampos.set(33, 'btn_cancelar_modificar');

        

        this.arrayObjetos.set(1, 'activos_fijos_series_bodegas_nitsx_sedes_id');
        this.arrayObjetos.set(2, 'activos_fijos_series_id');
        this.arrayObjetos.set(3, 'activos_fijos_bodegas_nitsx_sedes_id');
        this.arrayObjetos.set(4, 'activos_fijos_bodegas_id');
        this.arrayObjetos.set(5, 'codigo_serie');
        this.arrayObjetos.set(6, 'nombre_serie');
        this.arrayObjetos.set(7, 'estado_serie');
        this.arrayObjetos.set(8, 'codigo_bodega');
        this.arrayObjetos.set(9, 'descripcion_bodega');
        this.arrayObjetos.set(10, 'tipo_bodega');
        this.arrayObjetos.set(11, 'tarifa');
        this.arrayObjetos.set(12, 'descuento');
        this.arrayObjetos.set(13, 'precio');
        this.arrayObjetos.set(14, 'fecha_inicial');
        this.arrayObjetos.set(15, 'fecha_final');
        this.arrayObjetos.set(16, 'nit');
        this.arrayObjetos.set(17, 'sede');
        this.arrayObjetos.set(18, 'nombre');
        this.arrayObjetos.set(19, 'estadoactivo_id');

        this.arrayObjetos.set(30, 'btn_agregar');
        this.arrayObjetos.set(31, 'btn_cancelar');
        this.arrayObjetos.set(32, 'btn_modificar');
        this.arrayObjetos.set(33, 'btn_cancelar_modificar');

        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19', 'visible', 'false')
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19', 'disable', 'true')

        //inicio form
        this.establecerPropiedades('5,6,7,8,9,10,11,12,13,14,15,16,17,18,19', 'visible', 'true');

        this.getField('btn_cancelar').setClick(() => {
            this.traer_por_id = false;
            this.btnCancelarRegistro();
        });
        this.getField('btn_agregar').setClick(() => {
           
            if ( this.getField("activos_fijos_series_id").valid() &&
            this.getField("activos_fijos_bodegas_nitsx_sedes_id").valid() && this.getField("codigo_serie").valid() &&
            this.getField("tarifa").valid() && 
            this.getField("descuento").valid() && this.getField("precio").valid() && 
            this.getField("estadoactivo_id").valid() && this.getField("fecha_inicial").valid()&&
            this.getField("fecha_final").valid()
        ){
            if(Date.parse(this.getField("fecha_final").getValue()) < Date.parse(this.getField("fecha_inicial").getValue())){
                this.getField('fecha_final').setError(true,'* La fecha final no puede ser menor a la fecha inicial');
             }else{
                 this.validacionUnique();
            }
                

        }else {
            if (!(this.getField("activos_fijos_bodegas_nitsx_sedes_id").getValue())) {

                if(this.getField("codigo_serie").getValue() === "" || this.getField("codigo_serie").getValue()  === " "){
                    this.getField("codigo_serie").setError(true,'* Debe llenar este campo');
                } else if((this.getField("codigo_bodega").getValue() === "" || this.getField("codigo_bodega").getValue()  === " ") &&
                  (this.getField("nit").valid() )){
                    this.getField("codigo_bodega").setError(true,'* Debe llenar este campo');
                }else if((this.getField("nit").getValue() === "" || this.getField("nit").getValue() === " " ) && 
                ((this.getField("codigo_bodega").valid() ))){
                    this.getField("nit").setError(true,'* Debe llenar este campo');
                }
            }
        }
     
        });
        this.getField('btn_modificar').setClick(() => {
            if (this.getField('activos_fijos_series_id').valid() && this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').valid() 
                && this.getField('activos_fijos_bodegas_nitsx_sedes_id').valid()){
                    if(Date.parse(this.getField("fecha_final").getValue()) < Date.parse(this.getField("fecha_inicial").getValue())){
                        this.getField('fecha_final').setError(true,'* La fecha final no puede ser menor a la fecha inicial');
                     }else{
                         this.actualiarRegistro();
                     }
            }
        });

        this.getField('btn_cancelar_modificar').setClick(() => {
            this.traer_por_id = false;
            this.btnModificar = false;
            this.btnCancelarRegistro();
        });

        this.getField('fecha_final').setOnChange(()=>{ 
            if(Date.parse(this.getField("fecha_final").getValue()) >= Date.parse(this.getField("fecha_inicial").getValue()))
                this.getField('fecha_final').setError(false,'');
        });



    }
    cargarSelectEstadosActivos() {

        if (this.arrayEstadosActivos.length > 0) {
            let opciones = [{ 'text': 'Ninguno', 'value': ' ', 'campos_cambian': {} }];
            this.arrayEstadosActivos.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.value;
                /* dataOp['campos_cambian'] = { rack: item.id }; */
                opciones.push(dataOp);
            });
            this.getField('estadoactivo_id').setOptions(opciones);
        } 


    }

    onSelectionChanged() {
        let filaSeleccionada = this.gridOptionsTableDefault.api.getSelectedRows();
        if (filaSeleccionada.length > 0) {
            this.llenar(filaSeleccionada);
            this.registro_seleccionado = true;
        } else {
            this.registro_seleccionado = false;
        }
    }

    handerClickShowTable() {
        this.registro_seleccionado = false;
        this.traer_por_id = false;
        /* this.traerPrimero(); */
        this.traerTodos();

    }

    handlerClickChange() {
        this.btnModificar = true;
        if (this.registro_seleccionado) {
            this.registro_seleccionado = false;
            this.establecerPropiedades('5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,32,33', 'disable', 'false');
            this.establecerPropiedades('32,33', 'visible', 'true');
            this.getField('btn_new').setVisible(false);
            this.getField('btn_show').setVisible(false);
            this.getField('btn_change').setVisible(false);
            this.getField('btn_delete').setVisible(false);
            this.getField('rejilla').toggle(false);
            /* this.getField('btn_imprimir').setVisible(false); */

            /* this.getField('departamento_geografico_id_1').setValue(this.getField('departamento_geografico_id_1').getValue()); */


        } else {
            this.mostrarMensajeSeleccionModificar();
        }
    }

    handlerClickNew() {
        this.btnModificar = false;
        this.registro_seleccionado = false;
        this.establecerPropiedades('5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,30,31', 'disable', 'false');
        this.establecerPropiedades('30,31', 'visible', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19', 'value', '');


        this.getField('btn_new').setVisible(false);
        this.getField('btn_show').setVisible(false);
        this.getField('btn_change').setVisible(false);
        this.getField('btn_delete').setVisible(false);
        this.getField('rejilla').toggle(false);

    }

    handlerClickDelete() {
        this.traer_por_id = false;
        if (this.registro_seleccionado) {
            this.confirmarEliminacionRegistro();
            this.registro_seleccionado = false;
        } else {
            this.mostrarMensajeSeleccionEliminar();
        }
    }

    mostrarMensajeSeleccionModificar() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No se ha seleccionado ningún registro para modificar');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeSeleccionEliminar() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No se ha seleccionado ningún registro para eliminar');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    btnCancelarRegistro() {
        this.getField('confirmModalCustom').toggle(false);
        this.registro_seleccionado = false;
        this.getField('btn_agregar').setVisible(false);
        this.getField('btn_cancelar').setVisible(false);
        this.getField('btn_modificar').setVisible(false);
        this.getField('btn_cancelar_modificar').setVisible(false);
        this.getField('btn_new').setDisabled(false);
        this.getField('btn_show').setDisabled(false);
        this.getField('btn_delete').setDisabled(false);

        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19', 'disable', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19', 'value', '');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19', 'error', 'false');
        if (this.traer_por_id)
            this.traerPorId();
        else
            this.traerUltimo();
        this.traerTodos();


        this.getField('btn_new').setVisible(true);
        this.getField('btn_show').setVisible(true);
        this.getField('btn_change').setVisible(true);
        this.getField('btn_delete').setVisible(true);

/*         this.gridOptionsTableDefault["rowData"] = [];
        this.getField('rejilla').initData(this.gridOptionsTableDefault);
        this.getField('rejilla').toggle(false); */
        this.btnModificar = false;
    }

    validacionUnique() {
        
        
        if (this.getField('activos_fijos_series_id').getValue() !== '' && this.getField('activos_fijos_bodegas_nitsx_sedes_id').getValue() !== ' ' && 
        this.getField('activos_fijos_series_id').getValue() !== '' && this.getField('activos_fijos_bodegas_nitsx_sedes_id').getValue() !== ' '
        ) {
            let datos = {
                datos: {
                    activos_fijos_bodegas_nitsx_sedes_id: this.getField('activos_fijos_bodegas_nitsx_sedes_id').getValue(),
                    activos_fijos_series_id: this.getField('activos_fijos_series_id').getValue(),
                }
            };
            let operacion = '20';
            
/*             if (this.btnModificar) {
                datos.datos['activos_fijos_bodegas_id'] = this.getField('activos_fijos_bodegas_id').getValue();
                operacion = '20_modificar';
            } */
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijoseriesbodnit', operacion: operacion, operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successValidarUniqueRegistro,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        } 
    }

    successValidarUniqueRegistro(data) {
        if (data.estado_p === 200) {
            this.alertGeneral.toggle(true, 'El código serie y el activo fijo bodega ya se encuentra asignado a un registro', 'error');
        } else if(data.estado_p === 404){

            this.crearRegistro();

        }
    }

    traerPorId() {
        let id_activo_fijo_serie_bodega = (this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').getValue() === null ||
        this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').getValue() !== '' || 
        this.getField('activos_fijos_bodegas_id').getValue() !== ' ' || 
        !isNaN(this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').getValue()) )
        ?  parseInt(localStorage.getItem('activos_fijos_series_bodegas_nitsx_sedes_id')):
        this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').getValue();


        if (id_activo_fijo_serie_bodega !== '' && id_activo_fijo_serie_bodega !== ' ' && id_activo_fijo_serie_bodega !== null && !isNaN(id_activo_fijo_serie_bodega) ) {
            let datos = {
                datos: {
                    activos_fijos_series_bodegas_nitsx_sedes_id: id_activo_fijo_serie_bodega
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijoseriesbodnit', operacion: '2', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successtraerPorId,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
            }
    }

    successtraerPorId(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data)
        } /* else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'Error obteniendo el registro', 'error');
            }
        } */
    }

    confirmarEliminacionRegistro() {
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de realizar esta acción?');
        this.getField('confirmModalCustom').setClickDialog(this.eliminarPorId);
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
            this.getField('confirmModalCustom').toggle(false);
            this.registro_seleccionado = true;
             });
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
        this.getField('confirmModalCustom').toggle(true);
    }

    validarRegistroEliminar() {
        /* this.getField('confirmModalCustom').toggle(false); */
        this.eliminarPorId();
    }

    succesvalidarRegistroEliminar(data) {
        if (data.data[0].cuantos === 0) {
            this.eliminarPorId();

        } else {
            this.alertGeneral.toggle(true, '* Este registro ya está siendo utilizado en otro formulario, no se puede eliminar', 'error')
            this.getField('confirmModalCustom').toggle(false);

        }
    }

    eliminarPorId() {
        let datos = {
            datos: {
                activos_fijos_series_bodegas_nitsx_sedes_id: this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').getValue()
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijoseriesbodnit', operacion: '7', operacion_tipo: 'eliminar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: datos,
                success: this.successeliminarPorId,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage : false
            });
    }

    successeliminarPorId(data) {
        if (data.estado_p === 200) {
            this.getField('confirmModalCustom').toggle(false);
            this.traerPrimero();
            this.traerTodos();
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } else if (data.estado_p === 502) {
                /* let respuesta = Object.values(data.data.errores); */
                let mensajeError = ' Este registro se está usando en otro formulario, no se puede eliminar'  
                this.alertGeneral.toggle(true, mensajeError, 'error');
                this.getField('confirmModalCustom').toggle(false);
            
            } else {
                this.alertGeneral.toggle(true, 'No se pudo eliminar el registro', 'error');
                this.getField('confirmModalCustom').toggle(false);
            }
        }
    }

    crearRegistro() {
        if (this.getField("activos_fijos_series_id").valid() &&
        this.getField("codigo_serie").valid() &&
        this.getField("nombre_serie").valid() && this.getField("estado_serie").valid()&&

        this.getField("activos_fijos_bodegas_nitsx_sedes_id").valid() && this.getField("tarifa").valid() && 
        this.getField("descuento").valid() && this.getField("precio").valid() && 
        this.getField("estadoactivo_id").valid() && this.getField("fecha_inicial").valid()&&
        this.getField("fecha_final").valid()
    ) {
        

        if ((this.getField("codigo_bodega").getValue() !== '' || this.getField("codigo_serie").getValue() !== '') ||
             (this.getField("codigo_bodega").valid()  || this.getField("codigo_serie").valid())
            ) {
                
                let datos = {
                    datos: {
                        activos_fijos_series_id: parseInt(this.getField("activos_fijos_series_id").getValue()),
                        activos_fijos_bodegas_nitsx_sedes_id: parseInt(this.getField("activos_fijos_bodegas_nitsx_sedes_id").getValue()),
                        tarifa: parseFloat(this.getField("tarifa").getValue()),
                        descuento: parseFloat(this.getField("descuento").getValue()),
                        precio: parseFloat(this.getField("precio").getValue()),
                        fecha_inicial: this.getField("fecha_inicial").getValue(),
                        fecha_final: this.getField("fecha_final").getValue(),
                        estadoactivo_id: parseInt(this.getField("estadoactivo_id").getValue())
                    }
                }


            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijoseriesbodnit', operacion: '5', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successCrear,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            
        } else {
            this.alertGeneral.toggle(true, 'Debe llenar uno de los dos buscadores (Código Activo Fijo Bodega ó Nit)' , 'error');
        }

        }
    }

    successCrear(data) {
        if (data.estado_p === 200) {
            this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').setValue(data.data[0].activos_fijos_series_bodegas_nitsx_sedes_id);
            this.traer_por_id = true;
            this.btnCancelarRegistro();
            this.traerUltimo()
        } else {
            if (data.estado_p === 502) {
                let respuesta = Object.values(data.data.errores);
                let mensajeError = 'Error,  El código serie y el activo fijo bodega ya se encuentra asignado a un registro';
                if (respuesta.toString().includes('"activos_fijos_bodegas_nitsx_sedes_unique"')) {
                   mensajeError = 'El código serie y el activo fijo bodega ya están asociados a un registro'  
                }else{
                    mensajeError = 'Error creando el registro';
                } 
                this.alertGeneral.toggle(true, mensajeError , 'error');
            
            }else{
                this.alertGeneral.toggle(true, 'No se pudo crear el registro' , 'error');
            }

        }
    }

    actualiarRegistro() {
        if (this.getField("activos_fijos_series_bodegas_nitsx_sedes_id").valid() && this.getField("activos_fijos_series_id").valid() &&
        this.getField("activos_fijos_bodegas_nitsx_sedes_id").valid() && this.getField("codigo_serie").valid() &&
        this.getField("nombre_serie").valid() && this.getField("estado_serie").valid()&&
        this.getField("codigo_bodega").valid() &&
        this.getField("descripcion_bodega").valid() && this.getField("tipo_bodega").valid()&&
        this.getField("tarifa").valid() && 
        this.getField("descuento").valid() && this.getField("precio").valid() && 
        this.getField("estadoactivo_id").valid() && this.getField("fecha_inicial").valid()&&
        this.getField("fecha_final").valid() ) {

                

            let datos = {
                datos: {
                    activos_fijos_series_bodegas_nitsx_sedes_id: parseInt(this.getField("activos_fijos_series_bodegas_nitsx_sedes_id").getValue()),
                    activos_fijos_series_id: parseInt(this.getField("activos_fijos_series_id").getValue()),
                    activos_fijos_bodegas_nitsx_sedes_id: parseInt(this.getField("activos_fijos_bodegas_nitsx_sedes_id").getValue()),
                    tarifa: parseFloat(this.getField("tarifa").getValue()),
                    descuento: parseFloat(this.getField("descuento").getValue()),
                    precio: parseFloat(this.getField("precio").getValue()),
                    fecha_inicial: this.getField("fecha_inicial").getValue(),
                    fecha_final: this.getField("fecha_final").getValue(),
                    estadoactivo_id: parseInt(this.getField("estadoactivo_id").getValue())
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijoseriesbodnit', operacion: '6', operacion_tipo: 'modificar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: datos,
                    success: this.successActualizar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false

                });
        }
    }

    successActualizar(data) {
        if (data.estado_p === 200) {
/*             this.getField('activos_fijos_bodegas_id').setValue(data.data[0].activos_fijos_bodegas_id);
            localStorage.setItem('activos_fijos_bodegas_id', this.getField('activos_fijos_bodegas_id').getValue().toString())
            this.traer_por_id = true; */
            this.btnCancelarRegistro();
        }else {
            if (data.estado_p === 502) {
                let respuesta = Object.values(data.data.errores);
                let mensajeError = 'Error, El código serie y el activo fijo bodega ya se encuentra asignado a un registro';
                if (respuesta.toString().includes('"activos_fijos_series_bodegas_nitsx_sedes_unique"')) {
                   mensajeError = 'El código serie y el activo fijo boga ya están asociados a un registro'  
                }else{
                    mensajeError = 'Error actualizando el registro';
                } 
                this.alertGeneral.toggle(true, mensajeError , 'error');
            
            }else{
                this.alertGeneral.toggle(true, 'No se pudo actualizar el registro' , 'error');
            }

        }
    }


    traerTodos() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijoseriesbodnit', operacion: '1', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerTodos,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage : false
            });
    }

    successtraerTodos(data) {
        if (data.estado_p === 200) {
            //armar tabla
            let configCell = new Map();
            configCell.set('estadoactivo_id', { cellRenderer: (props) => { return "" + props.data.estadoactivo_id }, hide: true });
            configCell.set('activos_fijos_bodegas_nitsx_sedes_id', { cellRenderer: (props) => { return "" + props.data.activos_fijos_bodegas_nitsx_sedes_id }, hide: true });
            configCell.set('activos_fijos_series_id', { cellRenderer: (props) => { return "" + props.data.activos_fijos_series_id }, hide: true });
            configCell.set('tarifa', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.tarifa) },  });
            configCell.set('precio', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.precio) }, });
            configCell.set('descuento', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.descuento) },  });



            this.gridOptionsTableDefault['rowData'] = data.model;//los datos del servicio se cargan en la tabla por defecto del crud
            this.gridOptionsTableDefault['onSelectionChanged'] = this.onSelectionChanged;
            this.getField('rejilla').initData(this.gridOptionsTableDefault, configCell);
/*             this.getField('btn_imprimir').setVisible(true);
            this.getField('btn_imprimir').setDisabled(false); */
            this.registro_seleccionado = false;
        } else {
            /* this.getField('btn_imprimir').setVisible(false); */
            if (data.estado_p === 404) {   
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }else {
                this.alertGeneral.toggle(true, 'Error al traer todos los registros', 'error');
            }
            this.gridOptionsTableDefault['rowData'] = [];
            this.getField('rejilla').initData(this.gridOptionsTableDefault);
            this.getField('rejilla').toggle(false);
            this.limpiarCampos();
        }
    }

    traerPrimero() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijoseriesbodnit', operacion: '3', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerPrimero,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successtraerPrimero(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data);
        } else {
            this.limpiarCampos();
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro el registro.', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'Error Obteniendo el registro', 'error');
            }
            this.getField('rejilla').toggle(false);
        }
    }

    traerUltimo() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijoseriesbodnit', operacion: '4', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerUltimo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successtraerUltimo(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data);
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
            this.getField('rejilla').toggle(false);
/*             else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            } */
        }
    }

    currencyFormatterGeneral(number)
    {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
          if ((decimal !== 0) && (decimal !== undefined)) {
            if(decimal.length>2){
              decimal=(Number(number).toFixed(2) + "").split(".")[1];
            }
          return (this.formatNumberSaldo(number) + "," + decimal);
          } else {
          return this.formatNumberSaldo(number); }
    }

    formatNumberSaldo(number)
    {
            return Number(number).toString().split('.')[0]
             .toString()
             .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    llenar(data) {
        this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').setValue(data[0].activos_fijos_series_bodegas_nitsx_sedes_id);
        this.getField('activos_fijos_series_id').setValue(data[0].activos_fijos_series_id);
        this.getField('activos_fijos_bodegas_nitsx_sedes_id').setValue(data[0].activos_fijos_bodegas_nitsx_sedes_id);
        this.getField('activos_fijos_bodegas_id').setValue(data[0].activos_fijos_bodegas_id);
        this.getField('tarifa').setValue(data[0].tarifa);
        this.getField('descuento').setValue(data[0].descuento);
        this.getField('precio').setValue(data[0].precio);
        this.getField('codigo_bodega').setValue(data[0].codigo_bodega);
        this.getField('descripcion_bodega').setValue(data[0].descripcion_bodega);
        this.getField('tipo_bodega').setValue(data[0].tipo_bodega);
        this.getField('nit').setValue(data[0].nit);
        this.getField('sede').setValue(data[0].sede);
        this.getField('nombre').setValue(data[0].nombre);
        this.getField('codigo_serie').setValue(data[0].codigo_serie);
        this.getField('nombre_serie').setValue(data[0].nombre_serie);
        this.getField('estado_serie').setValue(data[0].estado_serie);
        this.getField('fecha_inicial').setValue(data[0].fecha_inicial);
        this.getField('fecha_final').setValue(data[0].fecha_final);
        this.getField('estadoactivo_id').setValue(data[0].estadoactivo_id);
            
         
    }

    limpiarCampos(){
        this.getField('activos_fijos_series_bodegas_nitsx_sedes_id').setValue('');
        this.getField('activos_fijos_series_id').setValue('');
        this.getField('activos_fijos_bodegas_nitsx_sedes_id').setValue('');
        this.getField('activos_fijos_bodegas_id').setValue('');
        this.getField('tarifa').setValue('');
        this.getField('descuento').setValue('');
        this.getField('precio').setValue('');
        this.getField('codigo_bodega').setValue('');
        this.getField('descripcion_bodega').setValue('');
        this.getField('tipo_bodega').setValue('');
        this.getField('nit').setValue('');
        this.getField('sede').setValue('');
        this.getField('nombre').setValue('');
        this.getField('codigo_serie').setValue('');
        this.getField('nombre_serie').setValue('');
        this.getField('estado_serie').setValue('');
        this.getField('fecha_inicial').setValue('');
        this.getField('fecha_final').setValue('');
        this.getField('estadoactivo_id').setValue('');
    }


    establecerPropiedades(sObjetos, sPropiedad, sValor) {
        const array = sObjetos.split(',');
        array.forEach((element) => {
            if (sPropiedad === 'disable') {
                if (sValor === 'true') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setDisabled(true);
                }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setDisabled(false);
                }
            }
            else if (sPropiedad === 'visible') {
                if (sValor === 'true') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setVisible(true);
                }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setVisible(false);
                }
            }
            else if (sPropiedad === 'value') {
                this.getField(this.arrayObjetos.get(parseInt(element))).setValue(sValor);
            }
            else if (sPropiedad === 'valid') {
                if (this.getField(this.arrayObjetos.get(parseInt(element))).isValid()) {
                    //ok
                }
                else {
                    this.bHayErrores = true;
                }
            }
            else if (sPropiedad === 'foco') {
                if (sValor === 'rejilla') { }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).input.focus();
                }
            }
            else if (sPropiedad === 'error') {
                if (sValor === 'false') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setError(false, '');
                }
            }
        });
    }

}
FormJaivana.addController("serlog-activosfijoseriesbodnit", CustomActivosFijosSeriesBodegasNitsxSedes);
export default CustomActivosFijosSeriesBodegasNitsxSedes